{partitionAndSort} = require '../../app/utils'

_ = require('lodash')

module.exports = (poller) ->
  return (url, key, value, callback) ->
    if !key or !value
      return

    if _.isObject(key)
      callback = value
      params = "?" + ("#{k}=#{v}" for k, v of key when v).join('&')
    else if value.constructor == Array
      params = "?#{key}=" + value.join("&#{key}=")
    else
      params = "?#{key}=#{value}"

    poller.reset()
    myPoller = poller.get(url + params, {smart:true, delay:20000})
    myPoller.promise.then null, null, (resp) ->
      callback(resp.data)

    myPoller
